/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var StackHDownIcon20Regular = forwardRef('StackHDownIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7 1.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H7Z" }),
        React.createElement("path", { d: "M4.25 5A.75.75 0 0 1 5 4.25h10a.75.75 0 0 1 0 1.5H5A.75.75 0 0 1 4.25 5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 7a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-5a3 3 0 0 0-3-3H5Zm10 1.5H5A1.5 1.5 0 0 0 3.5 10v5A1.5 1.5 0 0 0 5 16.5h10a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 15 8.5Z" })));
});
